import { DelegationData } from 'src/app/shared/models/delegation-data.model';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArchiveStatus } from 'src/app/billers/models/archive-status';
import { IStatusDefinition, LiabilityStatus, statusMap } from '../../../liabilities/models/model';
import { StatusType } from '../../models/status-type.enum';
import { getReturnUrlFromRoute } from '../../utils/return-url.utils';
import { AppConfig } from '../../../core/services/app-config.service';

@Component({
standalone: false,
  selector: 'app-liability-status',
  styleUrls: ['./liability-status.component.scss'],
  templateUrl: './liability-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiabilityStatusComponent implements OnChanges {
  @Input() public status: LiabilityStatus;
  @Input() public verified: boolean;
  @Input() public archiveStatus: ArchiveStatus;
  @Input() public id: string;
  @Input() public payId: string = null;
  @Input() public inCart = true;
  @Input() public delegationData: DelegationData;
  @Input() public paidBy: string;
  @Input() public showDelegationIcon = true;
  @Input() public showReclassified = false;

  public name: string;
  public type: StatusType;
  public tooltip: string | undefined;
  public icon: string;
  public statusType = StatusType;
  public archiveStatusType = ArchiveStatus;

  public hasAnyIcon = this.checkIfHasAnyIcon();

  constructor(private router: Router, private route: ActivatedRoute, private appConfig: AppConfig) {
  }

  public ngOnChanges(): void {
    const statusDefinition: IStatusDefinition =
      !this.appConfig?.config?.payment?.autoPayment?.enabled && this.status === 'SCHEDULED_NOT_PAID'
        ? {
          description: 'Zaplanowana',
          icon: 'schedule_send',
          tooltip:
            'Zaplanowane autopłatności nie zostaną wykonane. Więcej informacji znajdziesz w linku u góry strony.',
          type: StatusType.ERROR,
        }
        : statusMap[this.status];

    this.name = statusDefinition?.description;
    this.type = statusDefinition?.type;
    this.icon = statusDefinition?.icon;
    this.tooltip = this.getTooltip(statusDefinition);
  }

  private getTooltip(statusDefinition: IStatusDefinition) {
    if (this.paidBy) {
      return `${statusDefinition?.tooltip} przez ${this.paidBy}`;
    }
    return statusDefinition?.tooltip;
  }

  public goToCart(event): void {
    event.stopPropagation();
    if (this.payId) {
      this.router.navigate(['/liabilities/pay', this.payId], {
        queryParams: {
          returnUrl: getReturnUrlFromRoute(this.route),
        },
      });
    }
  }

  private checkIfHasAnyIcon(): boolean {
    return this.inCart || this.archiveStatus === ArchiveStatus.ARCHIVED || !!this.delegationData;
  }


  get statusClass(): any {
    if (!this.verified) {
      return 'liability-unverified';
    } else {
      if (LiabilityStatus.PAID_ON_PLATFORM === this.status) {
        return 'liabilities-paid-on-platform';
      } else if (LiabilityStatus.PAID_OUTSIDE_PLATFORM === this.status) {
        return 'liabilities-paid-outside-platform';
      } else if (LiabilityStatus.OVERDUE === this.status) {
        return 'liabilities-overdue';
      } else if (LiabilityStatus.NOT_PAID === this.status) {
        return 'liabilities-not-paid';
      } else if (LiabilityStatus.UNKNOWN === this.status) {
        return 'liabilities-unknown';
      } else {
        return 'liabilities-default';
      }
    }
  }

}
